import { UserListModel } from '../types/router-types';
import { Type, useRouteQuery } from './useRouteQuery';

export const useDefaultUserListRouteQuery = () =>
  useRouteQuery('userList', Type.isQueryString<UserListModel | undefined>, undefined);

export const useDefaultGroupListRouteQuery = () =>
  useRouteQuery('groupList', Type.isQueryString<UserListModel | undefined>, undefined);

export const useSelectedEntityRouteQuery = () => useRouteQuery('selected', Type.isString, undefined);

export const useDefaultListRouteQuery = () => useRouteQuery('list', Type.isString, 'users');

export const useDefaultOrganizationRouteQuery = () => useRouteQuery('organization', Type.isString, undefined);
